<template>
  <div>
    <el-drawer @reload="$reloadHandle" title="服务商确认" size="30%" :before-close="handleClose" :visible.sync="drawer"
      append-to-body="ture" direction="rtl" :modal-append-to-body="true" custom-class="demo-drawer" ref="drawer">
      <i class="el-icon-info" />
      单据号：<span v-if="exchangeNo" style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{
        exchangeNo }}</span>
      <div class="demo-drawer__content">
        <div id="containt">
          <div class="tab-box">
            <el-form :label-position="right" label-width="80px" ref="editForm" :model="formData">
              <el-form-item label="是否异议" >
                <el-select v-model="formData.diffFlag" style="width:10vw!important;" :disabled="able">
                  <el-option :value="0" label="否"></el-option>
                  <el-option :value="1" label="是"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="异议说明" >
                <el-input type="textarea" autocomplete="off" v-model="formData.diffNote" :disabled="able"
                style="width:10vw!important;" clearable />
              </el-form-item>
              <el-form-item label="异议附件" >
                <div class="form_picture">
                  <!-- <photo-upload :photo-url.sync="company.electronicInstructionManual"/> -->
                  <text-upload :photo-url.sync="checkFileObj" :disabled="able" />
                </div>
              </el-form-item>
              <el-form-item label="备 注" >
                <el-input type="textarea" autocomplete="off" v-model="formData.messageContent" :disabled="able"
                  style="width:10vw!important;" clearable />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <div class="demo-drawer__content">
        <div class="demo-drawer__footer" style="position: absolute;
    bottom: 5px;
    right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="siteAppeal">
            确 定
          </el-button>
        </div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import api from "@/api/projectApi";
import { dictType, loadDictData } from "@/config/dictType";
// 文件上传
import textUpload from "@/components/formItem/textUpload.vue"


export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'confirmNo', 'dataId', 'wf'],
  components: {
    textUpload,
  },
  created() {
    console.log(this.wf)
    this.formData.id = this.dataId
    if (this.wf) {
      this.exchangeNo = this.wf.orderNo
      this.formData.processId = this.wf.processId
      this.formData.taskId = this.wf.taskId
      this.formData.messageContent = this.wf.messageContent
      this.formData.id = this.wf.orderId
    }
  },
  data() {
    return {
      uploadFileUrl: api.uploadFileUrl,
      logisticsCompaniesList: [],
      exchangeNo: '',
      checkFileObj: null,

      formData: {
        id: null,
        processId: null,
        diffFlag: null,
        diffFile: null,
        diffNote: null,
        messageContent: null,
      },
      showOrderPop: false,

      drawer: true,
    }
  },
  methods: {
    // 考核的确认
    siteAppeal() {
      if (this.checkFileObj && this.checkFileObj.length > 0) {
        this.formData.diffFile = this.checkFileObj[0]['url']
      }
      this.$http({
        url: api.wkFeeApply.addDataUrl + "siteCheck",
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('确认成功')
        this.$emit('closeD')
        this.$emit('flushed')
      })
    },
    // 加载数据字典中物流公司，运输方式
    loadDictData() {
      // 物流公司
      loadDictData(dictType.logisticsCompanies).then(res => {
        this.logisticsCompaniesList = []
        res.data.data.forEach(item => {
          this.logisticsCompaniesList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },
    confirm() {
      this.drawer = false;
      this.handleClose()
    },
    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
    },
    handleClose() {

      this.drawer = false;
      this.$emit('closeD', false)
    }
  },
  mounted() {
    this.loadDictData()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
</style>
